module.exports = __webpack_public_path__ + "img/contact-bjornbylund.b5774096.png";